import { css } from "@emotion/react";

export const VipDetailsItemStyle = {
  wrapper: css`
    position: relative;

    width: 450px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      display: flex;
      justify-content: center;
      align-items: center;
    }
  `,

  textBox: css`
    position: absolute;
    top: 80px;
    left: 20px;
    width: 60%;
    color: #fff;
    font-weight: bold;
    text-shadow:
      -1px -1px 0 #000,
      1px -1px 0 #000,
      -1px 1px 0 #000,
      1px 1px 0 #000;
    h4 {
      font-family: inherit;
      font-weight: 500;
      line-height: 1.1;
      font-size: 66px;
    }
  `,

  info: css`
    display: flex;
    align-items: center;
    justify-content: space-around;

    margin-bottom: 70px;
    padding-top: 185px;
    span {
      width: 120px;
      line-height: 15px;
      word-break: break-all;
      font-weight: bold;
      text-align: center;
      color: #f00;
    }
  `,
};
